import styled from 'styled-components'

export const AuthorDetails = styled.div`
  display: flex;
  align-items: center;
`